import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ProductService } from 'src/app/market-place/services/product.service';
import { StorageService } from '../../services/storage.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-share-review',
  templateUrl: './share-review.component.html',
  styleUrls: ['./share-review.component.scss'],
})
export class ShareReviewComponent implements OnInit {
  @Input() productId: number = undefined;
  public rating: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private productSv: ProductService,
    private storageSv: StorageService,
    private toastSv: ToastService
  ) { }

  ngOnInit() {
    this.rating = this.fb.group({
      qualification: ['', Validators.required],
      detail: ['', Validators.required]
    });
  }

  async share(){
    const user = await this.storageSv.get('userLogin');
    if(!user){
      return await this.toastSv.show('Debes iniciar sesión para poder realizar una opinión');
    }
    this.rating.value.name = user.name;
    this.rating.value.productId = this.productId;
    console.log(this.rating.value, this.productId);
    const res: any = await this.productSv.postReview(this.rating.value);
    if(res.status){
      this.rating.reset();
      await this.toastSv.show('Enviado con éxito.');
    }
  }
}
